import React from 'react';
import CheckIcon from '../../assets/icons/GreenCheckCircle.svg';

interface PostalAddressFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const PostalAddressField: React.FC<PostalAddressFieldProps> = ({ value, onChange, error }) => (
  <div className={error ? 'error' : ''}>
    <div
      className={`input-label-wrapper ${value ? 'isFilled' : ''} ${value && !error ? 'input-success' : ''}`}
    >
      {value && !error && (
        <img src={CheckIcon} alt='Check' width={18} height={18} className='success-icon' />
      )}
      <input
        type='text'
        className='input-field-style'
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <label className='input-label-title'>
        Postal address <span className='required'>*</span>
      </label>
    </div>
    {error && <div className='error-text-message'>{error}</div>}
  </div>
);

export default PostalAddressField;
